import { render, staticRenderFns } from "./DevelopmentContainer.vue?vue&type=template&id=495492b1&lang=pug&"
import script from "./DevelopmentContainer.vue?vue&type=script&lang=js&"
export * from "./DevelopmentContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VFlex})
